/*** IMPORTS FROM imports-loader ***/
var define = false;

"use strict";

function has(object, key) {
  return Object.prototype.hasOwnProperty.call(object, key);
}

module.exports = has;
